
import { adapterFaqDetails } from '@Adapters/cms/faq.adapter';
import errorHandler from '@Utils/error-handler';

export default {
  name: 'EditoFaq',
  props: {
    /**
     * Question max number
     */
    limit: {
      type: Number,
      default: 5,
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: undefined,
    },
    /**
     * Topic target page
     */
    topic: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      questions: undefined,
    };
  },
  mounted() {
    this.fetchCMSData();
  },
  methods: {
    async fetchCMSData() {
      try {
        if (!this.topic) {
          return;
        }

        const data = await this.$publicAPI.cms.getEntry('faq_thematic_page', {
          params: {
            targetPage: this.topic,
          },
        });
        const { details = {} } = adapterFaqDetails(data, this, {
          limit: this.limit,
        });
        const { questions } = details;

        if (!questions) {
          return;
        }

        this.questions = questions;
      } catch (err) {
        errorHandler(err, this, {
          logOnly: true,
          path: 'pages.faq.details.fetchCMSData',
        });
      }
    },
  },
};
